function SvgComponent(props: any) {
    return (
      <svg
        width={164}
        height={96}
        viewBox="0 0 164 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M106.137 86.5a9.5 9.5 0 01-9.5 9.5h-30a9.5 9.5 0 010-19h.24a9.778 9.778 0 01-5-8.535c0-5.402 4.379-9.78 9.78-9.78h-34.52c-5.402 0-9.78-4.38-9.78-9.781 0-5.402 4.378-9.781 9.78-9.781h37.964c-5.398-.005-9.772-4.382-9.772-9.781 0-5.402 4.379-9.78 9.78-9.78H26.782c-5.402 0-9.78-4.38-9.78-9.782C17 4.38 21.378 0 26.78 0h78.247c5.401 0 9.78 4.379 9.78 9.78 0 5.402-4.379 9.781-9.78 9.781h27.616c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.78-9.781 9.78h-13.799c5.397.005 9.772 4.383 9.772 9.782 0 5.401-4.379 9.78-9.781 9.78h34.52c5.402 0 9.781 4.38 9.781 9.781 0 5.402-4.379 9.781-9.781 9.781h-52.012a9.497 9.497 0 014.793 8.254z"
          fill="#EDFFF5"
        />
        <circle cx={134} cy={5.99951} r={2} fill="#D9D9D9" />
        <circle cx={43} cy={72.9995} r={2} fill="#D9D9D9" />
        <path
          d="M151.703 47.853l-.203-.28-.203.28-2.165 3-.286.396h5.308l-.286-.396-2.165-3zM3.717 12.874L3.5 12.5l-.217.375-2.165 3.75L.902 17h5.196l-.216-.375-2.165-3.75z"
          stroke="#D9D9D9"
          strokeWidth={0.5}
        />
        <path
          d="M104.906 37.781a12.094 12.094 0 10-24.187 0c0 4.961 3.97 11.428 12.094 19.173 8.124-7.745 12.093-14.212 12.093-19.173zM92.812 60.625c-9.855-8.957-14.78-16.574-14.78-22.844a14.782 14.782 0 0129.562 0c0 6.27-4.926 13.887-14.781 22.844z"
          fill="#219653"
        />
        <path
          d="M92.813 39.125a2.687 2.687 0 100-5.374 2.687 2.687 0 000 5.374zm0 2.688a5.375 5.375 0 110-10.75 5.375 5.375 0 010 10.75zm14.512 8.062l4.3 10.75H99.531v-2.688H86.094v2.688H74l4.3-10.75h29.025zm-2.894 0H81.194l-3.225 8.063h29.687l-3.225-8.063z"
          fill="#219653"
        />
        <circle cx={76} cy={61} r={12} fill="#EDFFF5" />
        <path
          d="M76 51a10 10 0 100 20 10 10 0 000-20zm4.3 7.61l-4.57 6a1 1 0 01-1.58.01l-2.44-3.11a1 1 0 111.58-1.23l1.63 2.08 3.78-5a1.005 1.005 0 111.6 1.22v.03z"
          fill="#219653"
        />
      </svg>
    )
  }
  
  export default SvgComponent